export const SELFHOST_FREE_MEMBER_LIMIT = 2_147_483_647;
export const SELFHOST_FREE_STORAGE_QUOTA = 1024 * 1024 * 1024 * 1024 * 1024;
export const SELFHOST_FREE_HISTORY_PERIOD_SECONDS = 2_147_483_647;

export const isSelfhostUnlimitedMemberLimit = (value: number) =>
  value === SELFHOST_FREE_MEMBER_LIMIT;

export const isSelfhostUnlimitedStorage = (value: number) =>
  value === SELFHOST_FREE_STORAGE_QUOTA;

export const isSelfhostUnlimitedHistory = (value: number) =>
  value === SELFHOST_FREE_HISTORY_PERIOD_SECONDS;
